import { graphql } from 'gatsby';
import React from 'react';
import LayoutDefault from '../../layouts/LayoutDefault';
import PageMetaData from '../../components/layout/PageMetaData';
import EuProjects from '../../components/sections/eu-projects/EuProjects';
import { EuProject } from '../../types/eu-project';
import { AllJsonData } from '../../types/graphql';
import { PolicyContent } from '../../types/policy-content';

interface EuProjectsPageProps extends AllJsonData<EuProject, { allJson: [] }> {}

const EuProjectsPage: React.FC<EuProjectsPageProps> = ({ data }) => {
  const euProjectsContent = data?.allJson.nodes || [];

  return (
    <LayoutDefault>
      <PageMetaData title="EU Projects" />
      <EuProjects content={euProjectsContent} />
    </LayoutDefault>
  );
};

export const query = graphql`
  query EuProjects {
    allJson(filter: { title: { eq: "euProjectsContent" } }) {
      nodes {
        contentEn
        header
        image {
          publicURL
        }
      }
    }
  }
`;

export default EuProjectsPage;
